(function () {
    const slideshow = document.querySelector('.site-header-slideshow');

    if (!slideshow) {
        return;
    }

    const slides = Array.from(slideshow.querySelectorAll('.site-header-slide'));

    const numberSetting = (value, fallback, minimum, maximum) => {
        const number = Number.parseFloat(value);

        if (!Number.isFinite(number)) {
            return fallback;
        }

        return Math.min(Math.max(number, minimum), maximum);
    };

    const slideTime = numberSetting(slideshow.dataset.slideTime, 7, 1, 60);
    const transitionTime = numberSetting(slideshow.dataset.transitionTime, 1.5, 0.1, 10);
    const zoomLimit = numberSetting(slideshow.dataset.zoomLimit, 3, 0, 15);

    slideshow.style.setProperty('--marta-slide-time', `${slideTime}s`);
    slideshow.style.setProperty('--marta-transition-time', `${transitionTime}s`);
    slideshow.style.setProperty('--marta-zoom-scale', String(1 + zoomLimit / 100));

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length < 2 || reducedMotion) {
        return;
    }

    let activeIndex = 0;
    let timer;
    let transitionTimer;
    let nextSlidePromise;
    let visibilityGeneration = 0;
    const failedSlides = new Set();
    const slideLoads = new WeakMap();

    const scheduleNextSlide = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(showNextSlide, (slideTime + transitionTime) * 1000);
    };

    const imageReady = (image) => {
        if (image.complete) {
            return Promise.resolve(image.naturalWidth > 0);
        }

        return new Promise((resolve) => {
            image.addEventListener('load', () => resolve(true), {once: true});
            image.addEventListener('error', () => resolve(false), {once: true});
        });
    };

    const loadSlide = (slide) => {
        if (slideLoads.has(slide)) {
            return slideLoads.get(slide);
        }

        const picture = slide.closest('picture');

        if (picture) {
            picture.querySelectorAll('source[data-srcset]').forEach((source) => {
                source.srcset = source.dataset.srcset;
            });
        }

        if (slide.dataset.srcset) {
            slide.srcset = slide.dataset.srcset;
        }

        if (slide.dataset.src) {
            slide.src = slide.dataset.src;
        }

        const load = imageReady(slide);
        slideLoads.set(slide, load);

        return load;
    };

    const loadNextAvailable = async (fromIndex) => {
        for (let offset = 1; offset < slides.length; offset += 1) {
            const candidateIndex = (fromIndex + offset) % slides.length;
            const candidate = slides[candidateIndex];

            if (failedSlides.has(candidate)) {
                continue;
            }

            if (await loadSlide(candidate)) {
                return candidateIndex;
            }

            failedSlides.add(candidate);
        }

        return null;
    };

    const showNextSlide = async () => {
        const generation = visibilityGeneration;
        const outgoingIndex = activeIndex;
        const nextIndex = await nextSlidePromise;

        if (nextIndex === null || document.hidden || generation !== visibilityGeneration || outgoingIndex !== activeIndex) {
            return;
        }

        const outgoingSlide = slides[activeIndex];

        outgoingSlide.classList.add('is-leaving');
        activeIndex = nextIndex;
        slides[activeIndex].classList.add('is-active');

        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(() => {
            outgoingSlide.classList.remove('is-active', 'is-leaving');
        }, transitionTime * 1000);

        nextSlidePromise = loadNextAvailable(activeIndex);
        scheduleNextSlide();
    };

    const start = () => {
        slides.forEach((slide) => slide.classList.remove('is-active', 'is-leaving'));
        slides[0].classList.add('is-active');
        activeIndex = 0;
        nextSlidePromise = loadNextAvailable(activeIndex);

        window.requestAnimationFrame(() => {
            slideshow.classList.add('is-ready');
            timer = window.setTimeout(showNextSlide, slideTime * 1000);
        });
    };

    loadSlide(slides[0]).then((loaded) => {
        if (loaded) {
            start();
        }
    });

    document.addEventListener('visibilitychange', () => {
        visibilityGeneration += 1;
        window.clearTimeout(timer);

        if (document.hidden) {
            window.clearTimeout(transitionTimer);
            slides.forEach((slide, index) => {
                slide.classList.toggle('is-active', index === activeIndex);
                slide.classList.remove('is-leaving');
            });
        } else if (slideshow.classList.contains('is-ready')) {
            scheduleNextSlide();
        }
    });
}());
